<template>
    <section class="section">
      <!-- <div class="field has-addons is-pulled-right">
        <div class="control">
          <input class="input " v-model="search" @keydown="searchBlog" type="text" placeholder="Search..">
        </div>
        <div class="control">
          <touch-ripple :speed="1" :opacity="0.1" color="#fff" transition="ease">
          <button  class="button is-puple">
            <i class="fa fa-search"></i>
          </button>
          </touch-ripple>
        </div>
      </div> -->

      <cham-blog-post v-for="blog in blogs" :key="blog.slug" :post="blog" @click.native="goToPost(blog.slug)"/>
      <!-- <cham-blog-post/>
      <cham-blog-post/>
      <cham-blog-post/>
      <cham-blog-post/> -->
      <!-- <button v-waves.button  class="button is-fullwidth is-puple">Load More</button> -->


    </section>
</template>

<script>
import router from '../router';


export default {
  name: 'BlogContainer',
  props : ['blogs'],
  data () {
    return {
      search : '',
      blogPosts: null
    }
  },
  methods : {
    goToPost (slug) {
      router.push('/blog/'+slug)
    },
    searchBlog() {
      this.$emit('c-search' , this.search)
    }
  },
  mounted () {

  },

}
</script>

<style lang="scss">
@import '../../static/styles.scss';
@import '../../static/_variables.scss';

</style>



// WEBPACK FOOTER //
// src/componests/BlogContainer.vue